import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Button,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useNavigate } from "react-router-dom";
import RejectedLoanImage from "../../../assets/img/rejected-loan.png";
import brandTheme from "brandTheme/Theme";
import { useSelector } from "react-redux";
import { apiHandler } from "assets/api";
import { endpoint } from "assets/api/endpoint";

const useStyles = makeStyles(() => ({
  root: {
    minHeight: "100vh",
    background: brandTheme.fullSiteBackgroundColor,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "20px",
  },
  card: {
    background: brandTheme.white,
    borderRadius: 12,
    padding: "40px 30px",
    textAlign: "center",
    maxWidth: 500,
    width: "100%",
    boxShadow: `0 8px 24px ${brandTheme.shaddowColor}40`,
  },
  image: {
    width: 220,
    maxWidth: "100%",
    marginBottom: 25,
  },
  title: {
    color: brandTheme.mainColor,
    fontFamily: brandTheme.font.poppins,
    fontWeight: 600,
    fontSize: "28px",
    marginBottom: 12,
  },
  description: {
    color: brandTheme.lightBlack,
    fontFamily: brandTheme.font.roboto,
    fontSize: "16px",
    lineHeight: 1.6,
    marginBottom: 30,
  },
  button: {
    backgroundColor: brandTheme.buttonColor,
    color: brandTheme.white,
    textTransform: "none",
    padding: "12px 32px",
    fontSize: "16px",
    fontWeight: 600,
    borderRadius: 8,
    "&:hover": {
      backgroundColor: brandTheme.buttonHoverColor,
    },
  },
}));

const LoanRejected = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { leadId } = useSelector((state) => state.login.userCurrentLead);
  const { authToken } = useSelector((state) => state.login.authData);
  const [callInProgress, setCallInProgress] = useState(false);
  useEffect(() => {
    rejectApplciation();
  },[])

  const rejectApplciation = async () =>{
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.REJECT_LEAD_APPLICATION + leadId,
      method: "PUT",
      authToken,
    });
    if(result?.data?.error_code){
      setCallInProgress(false);
    }
  }
  const handleDashboard = () => {
    navigate("/dashboard");
  };

  return (
    <Box className={classes.root}>
      <Box className={classes.card}>
        <img
          src={RejectedLoanImage}
          alt="Loan Rejected"
          className={classes.image}
        />

        <Typography className={classes.title}>
          You are not eligible for the loan
        </Typography>

        <Typography className={classes.description}>
          Unfortunately, you do not meet the eligibility criteria for this loan at
          the moment.
          <br />
          <br />
          As per our policy, you can submit a new loan application after
          <strong> 3 months </strong>
          from the date of this decision. We look forward to serving you in the
          future.
        </Typography>

        <Button
          variant="contained"
          className={classes.button}
          onClick={handleDashboard}
        >
          Go to Dashboard
        </Button>
      </Box>
    </Box>
  );
};

export default LoanRejected;